import { PDE } from "../../htttp/urls";

export const imageUpload = async (payload) => {
  const res = await PDE.post("api/v1/featuredvideos", payload, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
    },
  });
  return res;
};

export const getAllDocuments = async () => {
  const res = await PDE.get("api/v1/featuredvideos");
  return res;
};

export const deleteDocumentById = async (id) => {
  const res = await PDE.delete(`api/v1/featuredvideos/${id}`);
  return res;
};
